// export const timeoutPromise = new Promise((resolve, reject) => {
// 	setTimeout(() => {
// 		reject(new Error('Request timed out achcccc'));
// 	}, 10000);
// });

import CryptoJS from 'crypto-js';
import { AppColors } from './AppColors';
import moment from 'moment';

function getValidColor(color, fallback) {
	return color && color.trim() !== '' ? color : fallback;
}
export function getColorSettings() {
	const navSettings = JSON.parse(localStorage.getItem('navSettings') || '{}');
	return {
		buttonBackground: getValidColor(navSettings.colorSettings?.buttonBackground, AppColors.Primary_shade),
		fontColor: getValidColor(navSettings.colorSettings?.fontColor, AppColors.DARKER_PRIMARY),
		tertiary: getValidColor(navSettings.colorSettings?.tertiary, AppColors.LIGHT_SHADE),
		quaternary: getValidColor(navSettings.colorSettings?.quaternary, AppColors.LIGHTER_SHADE),
		quinary: getValidColor(navSettings.colorSettings?.quinary, AppColors.LIGHTEST_SHADE),
	};
}

export function localData() {
	const navSettings = JSON.parse(localStorage.getItem('navSettings') || '{}');
	return navSettings;
}

export const randomIntArrayInRange = (min, max, n = 1) =>
	Array.from({ length: n }, () => Math.floor(Math.random() * (max - min + 1)) + min);

export const validateEmail = (email) => {
	let res = false;
	if (
		String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			)
	) {
		res = true;
	}
	return res;
};

export const validateUserEmail = (email) => {
	if (!email) return true;
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(email);
};

export const validateUserEmailSmallCase = (email) => {
	if (!email) return true;
	const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
	return emailRegex.test(email);
};

export const validatePhoneNumber = (phoneNumber) => {
	const nameRegex = /^[0-9]+$/;
	return nameRegex.test(phoneNumber);
};

// General Name Validation: Allow only letters and spaces for first/last names.
export const validateOtherFields = (name) => {
	const nameRegex = /^[a-zA-Z\s]*$/;
	return nameRegex.test(name);
};

// Sanitizer: Prevent script tags and special characters for other fields.
export const sanitizeInput = (value) => {
	return value.replace(/<\/?script>/gi, '').replace(/[^\w\s]/gi, '');
};

export const isInputClean = (value) => {
	const scriptTagRegex = /<\/?script>/gi;
	const specialCharRegex = /[^\w\s]/gi;
	return !scriptTagRegex.test(value) && !specialCharRegex.test(value);
};

export const filterBySearch = (items, term, keys) => {
	if (!term) return items;
	const getNestedValue = (obj, path) => {
		return path?.split('.')?.reduce((value, key) => {
			return value ? value[key] : undefined;
		}, obj);
	};
	return items?.filter((item) =>
		keys?.some((key) => {
			const value = getNestedValue(item, key);
			return value?.toString()?.toLowerCase()?.includes(term?.toLowerCase());
		}),
	);
};

export const filterBySearchPagination = (items, pagination, term, setLoading, setPagination, keys) => {
	setLoading(true);
	if (!items || !Array.isArray(items)) return [];

	// Filter based on the search term
	const filteredItems = term
		? items.filter((item) =>
				keys?.some((key) => {
					const getNestedValue = (obj, path) => path?.split('.')?.reduce((value, key) => (value ? value[key] : undefined), obj);
					const value = getNestedValue(item, key);
					return value?.toString()?.toLowerCase()?.includes(term?.toLowerCase());
				}),
		  )
		: items;

	// If no pagination is provided, return the filtered items as-is
	if (!pagination) {
		return filteredItems;
	}

	// Extract pagination data with defaults
	const { page = 1, rowsPerPage = 10 } = pagination;

	setPagination((prev) => ({
		...prev,
		count: filteredItems?.length,
		page: term ? 1 : pagination?.page,
		rowsPerPage: pagination?.rowsPerPage,
	}));

	// Calculate pagination start and end indices
	const startIndex = (page - 1) * rowsPerPage;
	const endIndex = startIndex + rowsPerPage;
	setLoading(false);

	// Return only the data for the current page
	return filteredItems.slice(startIndex, endIndex);
};

export const convertToQueryParams = (filters = {}) => {
	if (!filters || typeof filters !== 'object') return '';

	console.log('filters', filters);
	const singularKeyMap = {
		genders: 'gender',
		roles: 'role',
		timezones: 'timezone',
		departments: 'department',
	};

	const queryParams = Object.keys(filters)
		.map((key) => `${singularKeyMap[key] || key}=${filters[key].join(',')}`)
		.join('&');

	return queryParams;
};

export const getInitials = function ({ user }) {
	let firstName = user?.firstName;
	let lastName = user?.lastName;
	let initials = !firstName && !lastName ? 'na' : (firstName?.[0] || '') + (lastName?.[0] || '');
	return initials.toUpperCase();
};

export const copyToClipboard = (url) => {
	const dummy = document.createElement('input');
	document.body.appendChild(dummy);
	dummy.value = url;
	dummy.select();
	dummy.setSelectionRange(0, Math.max(url?.length + 1, 99999));

	if (navigator?.clipboard?.writeText) {
		navigator.clipboard.writeText(dummy.value).then(() => document.body.removeChild(dummy));
	} else {
		document.execCommand('copy');
		document.body.removeChild(dummy);
	}
};

export function camelCaseToCapitalized(camelCaseString) {
	return camelCaseString
		.replace(/([a-z])([A-Z])/g, '$1 $2') // Add spaces before uppercase letters
		.replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
}

export const extractNumberFromString = (string) => {
	return parseFloat(string.replace('%', ''));
};

export const formatAndSortInsights = (data) => {
	return data
		?.map((parent) => {
			const updatedSubTopics = parent?.subTopic
				?.map((subTopic) => {
					const totalUsers = subTopic?.cluster?.reduce((sum, c) => sum + c?.unique_users, 0);
					return { ...subTopic, total_users: totalUsers };
				})
				.sort((a, b) => b?.total_users - a?.total_users);

			const totalUsersParent = updatedSubTopics?.reduce((sum, st) => sum + st?.total_users, 0);

			return { ...parent, subTopic: updatedSubTopics, total_users: totalUsersParent };
		})
		.sort((a, b) => b?.total_users - a?.total_users);
};

export const getFilteredAndSortedUsers = (details, searchTerm, pagination, setPagination , type) => {
	const term = searchTerm.toLowerCase();



	// Filter users based on the search term
	let filtered = (details?.compaignUser || []).filter((item) => {
		const name = `${item.userId?.firstName || ''} ${item.userId?.lastName || ''}`.toLowerCase();
		const email = item.userId?.email?.toLowerCase() || '';
		return name.includes(term) || email.includes(term);
	});

	  // Further filter users based on the call type (type from TAG_KEYS)
    if (type) {
        filtered = filtered.filter((item) => {
            const scheduled = !!item?.startDateTime;
            const pickedUp = !!item?.callPickedUp;
            const lastFailedCall = !!item?.lastFailedCall;

            if (type === '1') {
                // Total: return all
                return true;
            }
            if (type === '2') {
                // Scheduled: scheduled && !pickedUp
                return scheduled && !pickedUp && !lastFailedCall;
            }
            if (type === '3') {
                // Rescheduled: lastFailedCall && scheduled
                return lastFailedCall && scheduled;
            }
            if (type === '4') {
                // Completed: scheduled && pickedUp
                return scheduled && pickedUp;
            }
            if (type === '5') {
                // Pending: not scheduled
                return !scheduled;
            }
            return true;
        });
    }

	// Sort the filtered users
	const sorted = filtered.sort((a, b) => {
		const getPriority = (item) => {
			const picked = item?.callPickedUp;
			const scheduled = !!item?.startDateTime;

			if (picked && scheduled) return 0;
			if (!picked && scheduled) return 1;
			return 2; // both false
		};

		return getPriority(a) - getPriority(b);
	});

	// Update pagination details
	const totalCount = sorted.length;
	const { page = 1, rowsPerPage = 10 } = pagination;

	const totalPages = Math.ceil(totalCount / rowsPerPage);
	const newPage = page > totalPages ? 1 : page;

	// Update pagination details
	setPagination((prev) => ({
		...prev,
		count: totalCount,
		page: newPage,
	}));

	// Apply pagination
	const startIndex = (page - 1) * rowsPerPage;
	const endIndex = startIndex + rowsPerPage;

	return sorted.slice(startIndex, endIndex);
};

export const getReportCallDetails = (details) => {
    let moreDetails = { totalCalls: 0, scheduled: 0, rescheduled: 0, completed: 0, pending: 0 };
    (details?.compaignUser || []).forEach((item) => {
        moreDetails.totalCalls += 1;
        const scheduled = !!item?.startDateTime;
        const pickedUp = !!item?.callPickedUp;
        const lastFailedCall = !!item?.lastFailedCall;

        if (scheduled && pickedUp) {
            moreDetails.completed += 1;
        } else if (scheduled && !pickedUp && !lastFailedCall) {
            moreDetails.scheduled += 1;
        } else if (lastFailedCall && scheduled) {
            moreDetails.rescheduled += 1;
        } else if (!scheduled) {
            moreDetails.pending += 1;
        }
    });

    return moreDetails;
};


// used to get 10:32 min:sec formate 
export const formatDuration = (start, end) => {
    const diffMs = new Date(end) - new Date(start);
    const minutes = Math.floor(diffMs / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);
    return `${minutes} min : ${seconds.toString().padStart(2, '0')} sec`;
};

const secret = 'your-very-secure-secret-key-32bytes!';
const key = CryptoJS.SHA256(secret); // same as Node's sha256 hash
// const test =
//   '7f1c3a18eb60d197c119847403e8f1a4:b368fc55fee64b89c0fbdcf9c3cb0751d4e356e9b440f49cf2fd333b355bdf42bf90b21b57ced3a4e1f8b0369837a8f7a57ca336ec4fea31d511d883a8338e3b8f80eec9f30cf3720a64bdf5547c29ea3aec6708b746a84f3cedc62eab0fe4466905b21c0592554a692333d7eeaf7d73c8fd1b59a821b60f7884fa0050343eed';
export const decryptIt = (encryptedText) => {
	// console.log('encryptedText',s encryptedText);
	if (!encryptedText) return '';
	const [ivHex, encryptedHex] = encryptedText?.split(':');
	const iv = CryptoJS.enc.Hex.parse(ivHex);
	const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);
	const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted);

	const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	return decrypted.toString(CryptoJS.enc.Utf8);
};

// Used to handle page number after any process like delete , archive etc
export const getSafePageAfterProcess = (correctDocumentLength , page) => {
    if(correctDocumentLength === 1 && page > 1) {
		const newPage = page - 1;
		return newPage;
	}
    return page;
};

export const getFormattedDuration = (start, end, format = 'mm:ss') => {
  const diff = moment(end).diff(moment(start)); // Calculate the difference in milliseconds
  return moment.utc(diff).format(format); // Format the duration
};
